// extracted by mini-css-extract-plugin
export default {"wrapper":"breadcrumbs-module--wrapper--2e945","innerWrapper":"breadcrumbs-module--innerWrapper--fecc0"};